import { render } from "./NotFoundComponent.vue?vue&type=template&id=91fc494a"
const script = {}
script.render = render

export default script